module.exports = __webpack_public_path__ + "img/normal.3a957fd3.jpg";